<template>
    <div class="queuing-info">
        <div class="queuing-title"></div>
        <div class="queuing-now">
            您当前处于第 <span>{{ seatNo }}</span> 位，共 <span>{{ queuingSize }}</span> 人排队
        </div>
        <div class="queue-status">正在排队，请耐心等待</div>
        <div class="cancel-queue" :class="{ disabled: canceling }" @click="cancelQueue"></div>
    </div>
</template>
<script>
export default {
    props: {
        seatNo: {
            type: Number,
            default: 0
        },
        queuingSize: {
            type: Number,
            default: 0
        },
        canceling: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        cancelQueue () {
            if (this.canceling) return
            this.$emit('cancelQueue')
        }
    }
}
</script>
<style scoped lang="less">
.queuing-info {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 5;

    .cancel-queue {
        width: 387px;
        height: 104px;
        background: url("@/assets/images/queue/cancel-queue.png") no-repeat;
        background-size: 100% 100%;
        margin-top: 106px;
        cursor: pointer;

        &.disabled {
            cursor: wait;
            opacity: 0.65;
            pointer-events: none;
        }
    }

    .queuing-title {
        width: 401px;
        height: 88px;
        background: url("@/assets/images/queue/queue-title.png") no-repeat;
        background-size: 100% 100%;
    }

    .queuing-now {
        color: #B0CAEB;
        width: 788px;
        height: 63px;
        background: url("@/assets/images/queue/queue-now.png") no-repeat;
        background-size: 100% 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 18px;
        margin: 18px 0 28px 0;

        span {
            color: #E33535;
            margin: 0 5px;
        }
    }

    .queue-status {
        color: #FFD293;
        font-size: 24px;
        line-height: 40px;
    }
}
</style>
